<template>
  <div class="mx-auto max-w-3xl">
    <form @submit.prevent="submit">
      <div class="border border-gray-200 rounded">
        <div v-if="required.length" class="px-5 pt-5 pb-10 rounded bg-gray-100">
          <h3
            class="text-center font-bold pb-5"
            v-text="i18n.parameters.required"
          ></h3>
          <div v-for="field in required" class="pb-2" :key="field.type">
            <div class="font-bold pb-1" :key="field.type + '-title'">
              <span class="toggle -required"></span>
              <label v-text="i18n.fields[field.type].required" />
            </div>
            <component
              :key="field.type"
              :is="field.type + '-field'"
              :options="field.options"
              :i18n="i18n.fields[field.type]"
              :required="true"
              v-model="form.value[field.type]"
              :errors="form.errors"
            />
          </div>
        </div>

        <div v-if="optional && optional.length" class="p-5">
          <h3 class="text-center font-bold" v-text="i18n.parameters.optional" />
          <p
            v-text="required.length ? i18n.some_optional : i18n.all_optional"
            class="py-2 italic"
          />
          <details
            v-for="field in optional"
            class="pb-2"
            :key="field.type"
            :open="fieldHasValue(field.type)"
          >
            <summary
              class="font-bold cursor-pointer"
              v-text="i18n.fields[field.type].optional"
            ></summary>
            <component
              class="pl-3"
              :key="field.type"
              :is="field.type + '-field'"
              :options="field.options"
              :i18n="i18n.fields[field.type]"
              :required="false"
              v-model="form.value[field.type]"
              :errors="form.errors"
            />
          </details>
        </div>
      </div>
      <div class="flex flex-col items-end py-2">
        <stacked-input
          :label="i18n.email"
          :required="true"
          :error="form.errors.email"
          class="w-64"
        >
          <input
            type="email"
            v-model="form.value.email"
            :class="{ danger: form.errors.email }"
            required
          />
        </stacked-input>
        <simple-checkbox
          class="w-64"
          :label="i18n.receive_finished_email"
          v-model="receive_finished_email"
          name="skip_finished_email"
        ></simple-checkbox>
      </div>
      <div class="flex justify-end text-xs pt-3">
        <div class="w-1/2">
          <p v-html="i18n.disclaimer" class="text-right" />
        </div>
      </div>
      <div class="flex justify-end">
        <ranch-button
          type="submit"
          :label="
            form.value.priority_id
              ? i18n.continue
              : i18n.continue_without_priority
          "
          :icon-after="true"
          icon="arrow-right"
          :loading="form.isSubmitting"
        ></ranch-button>
      </div>
    </form>
  </div>
</template>

<script>
import { handleNonValidationError } from "@/boot/functions";

import Size from "./fields/Size";
import Frames from "./fields/Frames";
import Spp from "./fields/Spp";
import Budget from "./fields/Budget";
import SL from "./fields/SL";
import Camera from "./fields/Camera";
import Take from "./fields/Take";
import Layer from "./fields/Layer";
import StackedInput from "../../../Design/Forms/StackedInput";
import SimpleCheckbox from "../../../Design/Forms/SimpleCheckbox";
import Form from "../../../../store/form";

let components = {
  "size-field": Size,
  "frames-field": Frames,
  "take-field": Take,
  "layer-field": Layer,
  "spp-field": Spp,
  "sl-field": SL,
  "budget-field": Budget,
  "camera-field": Camera,
};

export default {
  props: ["i18n", "input", "required", "optional", "storeUrl"],
  components: { ...components, StackedInput, SimpleCheckbox },
  data() {
    let fields = Object.keys(components).map((n) => {
      return n.split("-")[0];
    });

    return {
      fields,
    };
  },
  methods: {
    submit() {
      this.formSubmit()
        .then(({ data }) => {
          this.$emit("project-created", data);
        })
        .catch(handleNonValidationError);
    },
    fieldHasValue(name) {
      if (!this.input || !this.input[name]) {
        return false;
      }
      if (name === "frames") {
        return !!this.input.frames.specific_frames;
      }
      if (name === "size") {
        return !!(this.input.size.width || this.input.size.height);
      }
      return true;
    },
  },
  computed: {
    receive_finished_email: {
      get() {
        return !this.form.value.skip_finished_email;
      },
      set(v) {
        this.form.value.skip_finished_email = !v;
      },
    },
  },
  watch: {
    "input.priority_id": function (newValue) {
      this.form.value.priority_id = newValue;
    },
  },

  setup(props) {
    return Form(props.storeUrl, props.input);
  },
};
</script>
